import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import {UserTypesIcon, CrudStatus} from '../../../../common/enums'
import { APARTMENT_MODULE_NAMESPACE, APARTMENT_GET_APPARTMENTS, APARTMENT_EDIT_APARTMENT, APARTMENT_ACTION } from '../../../../store/apartment';
import { TENANT_MODULE_NAMESPACE, TENANT_GET_BLOCK_TENANTS } from '../../../../store/tenant';
import { OWNER_MODULE_NAMESPACE, OWNER_GET_BLOCK_OWNERS } from '../../../../store/owner';
import { IApartmentListingViewModel, IApartmentParameter } from '../../../../models/apartment';
import { PROFILE_EDIT_MEMBER, PROFILE_MODULE_NAMESPACE, PROFILE_SET_MEMBER_SELECTION, PROFILE_INIT_MEMBER_SELECTION, PROFILE_ACTION, PROFILE_GET_ALL_ENTITY_ROLES } from '../../../../store/profile/profile-types.store';
import {EQUIPMENT_EDIT, EQUIPMENT_GET_EQUIPMENTS, MAINTENANCE_MODULE_NAMESPACE} from "../../../../store/maintenance";
import {TranslateResult} from "vue-i18n";
import { eventBus } from '../../../../main';
import { SERIVCEBOOK_MODULE_NAMESPACE, SERVICEBOOK_GET_SERVICEBOOK } from '../../../../store/service-book';
import { IServiceBookDetails } from '../../../../store/service-book/service-book-state.store';

const BlockStore = namespace(APARTMENT_MODULE_NAMESPACE)
const TenantStore = namespace(TENANT_MODULE_NAMESPACE)
const OwnerStore = namespace(OWNER_MODULE_NAMESPACE)
const ApartmentStore = namespace(APARTMENT_MODULE_NAMESPACE);
const ProfileStore= namespace(PROFILE_MODULE_NAMESPACE)
const MaintenanceStore= namespace(MAINTENANCE_MODULE_NAMESPACE)
const ServiceBookStore = namespace(SERIVCEBOOK_MODULE_NAMESPACE)

@Component({
  components: {
    'sub-navigation-title-duplicate': async () => import('@/components/sub-navigation-title-duplicate/SubNavigationTitleDuplicate.vue'),
    'crud-menu': async () => import('@/components/crud-menu/CrudMenu.vue')
  }
})
class BlockDetailHeader extends Vue {
  @Prop({ default: 'Appartment 1', type: [String] })
  title: string;
  @Prop({ default: 1, type: [Number, String] })
  index: number | string;

  @BlockStore.Getter currentApartment: any;
  @TenantStore.Getter currentTenant: any;
  @OwnerStore.Getter currentOwner: any;
  @TenantStore.Getter tenants: any;
  @OwnerStore.Getter owners: any;
  @ApartmentStore.Getter apartments: IApartmentListingViewModel[];
  @MaintenanceStore.Getter equipments: any[];
  @MaintenanceStore.Getter currentEquipment: any;


  dtTitle: string;
  dtMenu: boolean;
  dtActionOpen: boolean;
  _timeout: any
  /**
   *
   */
  constructor() {
    super();
    this.dtTitle = null;
    this.dtMenu= false
    this.dtActionOpen= false
  }


  @ServiceBookStore.Action(SERVICEBOOK_GET_SERVICEBOOK)
  storeGetServiceBook: (id:string) => Promise<any>
  @ServiceBookStore.Getter currentServiceBook:IServiceBookDetails

  @TenantStore.Action(TENANT_GET_BLOCK_TENANTS)
  storeGetTenants: (payload: { param?: any, blockId: string }) => Promise<any>;
  @OwnerStore.Action(OWNER_GET_BLOCK_OWNERS)
  storeGetOwners: (payload: { param?: any, blockId: string }) => Promise<any>;
  @ApartmentStore.Action(APARTMENT_GET_APPARTMENTS)
  storeGetApartmentByBlockId: (payload: { param: IApartmentParameter, blockId: string, merge: boolean }) => Promise<IApartmentListingViewModel[]>;
  @ApartmentStore.Action(APARTMENT_EDIT_APARTMENT)
  storeEditApartment: () => void
  @ApartmentStore.Mutation(APARTMENT_ACTION)
  storeSetApartmentAction: (action: CrudStatus ) => void
  @ProfileStore.Action(PROFILE_EDIT_MEMBER)
  storeEditMember: (memberId?: number) => Promise<any>
  @ProfileStore.Mutation(PROFILE_SET_MEMBER_SELECTION)
  storeSetMemberSelection: (memberId: number) => void
  @ProfileStore.Mutation(PROFILE_INIT_MEMBER_SELECTION)
  storeInitMemberSelection: () => void
  @ProfileStore.Mutation(PROFILE_ACTION)
  storeSetProfileAction: (action: CrudStatus) => void
  @ProfileStore.Action(PROFILE_GET_ALL_ENTITY_ROLES)
  storeGetAllEntityRoles: () => Promise<any>
  @MaintenanceStore.Action(EQUIPMENT_GET_EQUIPMENTS)
  storeGetEquipments: (param: any) => Promise<any>
  @MaintenanceStore.Action(EQUIPMENT_EDIT)
  storeEditEquipment: () => void

  get lblSetting() {
    return {
      ...require('@/locales/block').default,
      ...require('@/locales/apartment').default,
      ...require('@/locales/profile').default,
      ...require('@/locales/equipment').default
    }
  }

  get isTenantPage(): boolean {
    return this.$route.name === 'block_tenant_details'
  }

  get isOwnerPage(): boolean {
    return this.$route.name === 'block_owner_details'
  }

  get isApartmentPage(): boolean {
    return this.$route.name === 'block_apartment_details'
  }

  get isEquipmentPage(): boolean {
    return this.$route.name === 'block_equipment_details' || this.$route.name === 'service_book_details'
  }

  get isVehiclePage(): boolean {
    return this.$route.name === 'block_vehicle_details'
  }

  get isContactPage() : boolean {
    return this.isOwnerPage || this.isTenantPage
  }

  get coTitle (): string {
    if (this.isApartmentPage)
      return this.currentApartment.apartment_number
    if (this.isContactPage)
      return this.isTenantPage ? `${this.coTenant.firstname} ${this.coTenant.lastname}`.trim() :
        this.isOwnerPage ? `${this.coOwner.firstname} ${this.coOwner.lastname}`.trim() : ''
    if (this.isEquipmentPage || this.isVehiclePage)
      return this.currentEquipment ? this.currentEquipment.name : ''
  }

  get coApartments(): any[] {
    if(!this.apartments) return []
    return this.apartments.map(apt => apt.apartment).map(apt => ({ ...apt, name: apt.apartment_number }))
  }

  get coMembers(): any[] {
    return this.isTenantPage ?
                    (this.tenants || []).map(item => ({ ...item, name: item.fullname.trim() })) :
                    (this.owners || []).map(item => ({ ...item, name: item.fullname.trim() }))
  }

  get coEquipments(): any[] {
    if(!this.equipments) return []
    return this.equipments
  }

  get coSource (): any[] {
    if (this.isApartmentPage)
      return this.coApartments
    if (this.isContactPage)
      return this.coMembers
    if (this.isEquipmentPage || this.isVehiclePage)
      return this.coEquipments
  }

  get coTenant(): any {
    return this.currentTenant.tenants.length ? this.currentTenant.tenants[0] : {}
  }

  get coOwner(): any {
    return this.currentOwner.owners.length ? this.currentOwner.owners[0] : {}
  }

  get coIcon(): string {
    if (this.isApartmentPage)
      return 'apt_icon'
    if (this.isTenantPage)
      return UserTypesIcon.TenantIcon
    if (this.isOwnerPage)
      return UserTypesIcon.OwnerIcon
    if (this.isEquipmentPage)
      return 'handyman'
    if (this.isVehiclePage)
      return 'time_to_leave'
  }

  get CoIsIcon(): boolean {
    return !this.isApartmentPage
  }

  get coMenuTexts(): {edit?: TranslateResult, delete?: TranslateResult, scheduleMaintenance?:TranslateResult,addDocToEquipment?:TranslateResult} {
    if (this.isApartmentPage)
      return {
        edit: this.$t(this.lblSetting.apartmentUpdate),
        delete: this.$t(this.lblSetting.apartmentDelete)
      }
    if (this.isContactPage)
      return {
        edit: this.$t(this.lblSetting.profileEditMember),
        delete: this.$t(this.lblSetting.profileDeleteMember)
      }
    if (this.isEquipmentPage)
      return {
        edit: this.$t(this.lblSetting.equipmentAction.edit),
        delete: this.$t(this.lblSetting.equipmentAction.delete),
        scheduleMaintenance: this.$t(this.lblSetting.equipmentAction.scheduleMaintenance),
        addDocToEquipment:this.$t(this.lblSetting.equipmentAction.addDocToEquipment)
      }
    if (this.isVehiclePage)
      return {
        edit: this.$t(this.lblSetting.vehicleAction.edit),
        delete: this.$t(this.lblSetting.vehicleAction.delete),
        scheduleMaintenance: this.$t(this.lblSetting.equipmentAction.scheduleMaintenance),
        addDocToEquipment:this.$t(this.lblSetting.equipmentAction.addDocToEquipment)
      }
  }

  get coMenuAuths(): {edit?: boolean, delete?: boolean, scheduleMaintenance?:boolean, addDocToEquipment?:boolean} {
    if (this.isApartmentPage)
      return Object.assign({},{
        edit: this.$route.meta['edit_apartment'],
        delete: this.$route.meta['delete_apartment']
      })
    if (this.isTenantPage)
      return Object.assign({},{
        edit: this.$route.meta['edit_tenant_account'],
        delete: this.$route.meta['delete_tenant_account']
      })
    if (this.isOwnerPage)
      return Object.assign({},{
        edit: this.$route.meta['edit_owner_account'],
        delete: this.$route.meta['delete_owner_account']
      })
    if (this.isEquipmentPage || this.isVehiclePage)
      return Object.assign({},{
        edit: this.$route.meta['manage_equipment'],
        delete: false,
        scheduleMaintenance:this.$route.meta['add_maintenance'],
        addDocToEquipment:this.$route.meta['create_document'],
      })
  }

  get coMenuKey(): string {
    if (this.isApartmentPage)
      return 'apartment_menu'
    if (this.isContactPage)
      return 'member_menu'
    if (this.isEquipmentPage)
      return 'equipment_menu'
    if (this.isVehiclePage)
      return 'vehicle_menu'
  }

  get isServiceBook():boolean {
    return this.$route.path.includes('service-book')
  }

  created() {
    const param: { blockId: string } =  { blockId: parseInt(this.$route.params.id).toString() }
    if(this.isTenantPage && !(this.tenants && this.tenants.length))
      this.storeGetTenants(param).then()

    if(this.isOwnerPage && !(this.owners && this.owners.length))
      this.storeGetOwners(param).then()

    if(this.isApartmentPage)
        this.setApartmentSettings()

    if (this.isEquipmentPage)
      this.setEquipmentSettings()
  }

  updated() {
    if(this.isApartmentPage) this.setApartmentSettings()
    if (this.isEquipmentPage) this.setEquipmentSettings()
  }

  setApartmentSettings(){
    if(!(this.apartments && this.apartments.length))
      this.storeGetApartmentByBlockId(
        {
          blockId: this.$route.params.id,
          param: { block: parseInt(this.$route.params.id), $limit: 100 },
          merge: false }
        ).then()
  }

  setEquipmentSettings() {
    if (!(this.equipments && this.equipments.length))
    {

      if(this.isServiceBook)
      {
        if(!this.currentServiceBook.apartment)
        {
          this.storeGetServiceBook(this.$route.params.id).then(()=>{
            //fk_apartment_block
            this.storeGetEquipments({
              block: this.currentServiceBook.apartment.fk_apartment_block,
              $limit: 100,
              disable: false,
              apartment:this.currentServiceBook.apartment.id
            }).then()
          })
        } else {
          //fk_apartment_block
          this.storeGetEquipments({
            block: this.currentServiceBook.apartment.fk_apartment_block,
            $limit: 100,
            disable: false,
            apartment:this.currentServiceBook.apartment.id
          }).then()
        }
      } else {
        this.storeGetEquipments({
          block: this.$route.params.id,
          $limit: 100,
          disable: false
        }).then()
      }

    }
  }

  handleClick(event?: { data: any }){
    clearTimeout(this._timeout)
    this._timeout= setTimeout(() => {
      this.dtMenu= false
      if(event.data.value === parseInt(this.$route.params.cid)) return
      let path: string = `/block/${this.$route.params.id}/`
      if (this.isApartmentPage)
        path += `apartment`
      if (this.isTenantPage)
        path += `tenant`
      if (this.isOwnerPage)
        path += `owner`
      if (this.isEquipmentPage)
        path += `equipment`
      path += `/${event.data.value}`
      this.$router.push({
        path,
        ... this.isApartmentPage && { query: { name: event.data.text }  },
        params: {
          id: this.$route.params.id,
          cid: event.data.value
        }
      })
    },200)
  }

  handleEditApartment () {
    this.storeEditApartment()
  }

  handleApartmentDelete () {
    this.storeSetApartmentAction(CrudStatus.Delete)
  }

  handleMemberEdit () {
    this.storeGetAllEntityRoles()
      .then(()=>{
        this.storeEditMember(parseInt(this.$route.params.cid))
        .catch(err=>{
          //this.dtMessageErrorModel= true
          //this.dtError= err
        })
      })
  }

  handleMemberDelete () {
    this.storeInitMemberSelection()
    this.storeSetMemberSelection(parseInt(this.$route.params.cid))
    this.storeSetProfileAction(CrudStatus.Delete)
  }

  handleEquipmentEdit () {
    this.storeEditEquipment()
  }

  handleEquipmentDelete () {

  }

  handleMenuEdit () {
    if (this.isApartmentPage)
      return this.handleEditApartment()
    if (this.isContactPage)
      return this.handleMemberEdit()
    if (this.isEquipmentPage || this.isVehiclePage)
      return this.handleEquipmentEdit()
  }

  handleMenuDelete () {
    if (this.isApartmentPage)
      return this.handleApartmentDelete()
    if (this.isContactPage)
      return this.handleMemberDelete()
    if (this.isEquipmentPage)
      return this.handleEquipmentDelete()
  }

  handleMenuScheduleMaintenance()
  {
    eventBus.$emit('SCHEDULE_MAINTENANCE_EQUIPMENT',{
      equipmentId:this.currentEquipment.id,
      categoryId:this.currentEquipment.category ? this.currentEquipment.category.id : null,
      subCategoryId:this.currentEquipment.subcategory ? this.currentEquipment.subcategory.id : null
    })
  }

  handleMenuAddDocToEquipment()
  {
    console.log('Open modal add doc')
    eventBus.$emit('ADD_DOCUMENT_TO_EQUIPMENT',{
      equipment:this.currentEquipment,
    })
  }
}

export default BlockDetailHeader;



// WEBPACK FOOTER //
// ./src/containers/block/components/block-detail-header/index.ts